import { Box, Stack, Typography } from "@mui/material";

import type { ActivationPageProps } from "../types";

export function ShipperVoluntellActivationPage1(props: ActivationPageProps) {
  const { passwordField, submitButton, errorMessage } = props;

  return (
    <Box>
      <Typography textAlign="center" variant="h4" fontWeight="bold">
        Evotrux is the fast, easy way to ship freight online.
      </Typography>
      <Typography textAlign="center" mt="2rem">
        Evotrux is your all-in-one freight management system. Procure trucks,
        track shipments, pay carriers, and analyze your data, all in one place,
        online.
      </Typography>
      <Typography textAlign="center" color="text.secondary" mt={3}>
        Create a password to activate your free account. No credit card
        required.
      </Typography>

      <Stack my="2rem" spacing={2}>
        {passwordField}
        {errorMessage}
        {submitButton}
      </Stack>
    </Box>
  );
}
